import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserDetail } from '../types/reduxStore';

const initialState: IUserDetail = {
    message: '',
    id: 0,
    firstName: '',
    lastName: '',
    grade: 0,
    email: '',
    roleId: 0,
    role: '',
    schoolId: 0,
    school: '',
    isActive: true,
};

export const userResponseSlice = createSlice({
    name: 'userResponse',
    initialState,
    reducers: {
        updateUserResponse: (state, action: PayloadAction<IUserDetail>) => {
            if (action.payload) {
                state.id = action.payload.id;
                state.firstName = action.payload.firstName;
                state.lastName = action.payload.lastName;
                state.grade = action.payload.grade ?? null;
                state.email = action.payload.email;
                state.roleId = action.payload.roleId;
                state.role = action.payload.role;
                state.schoolId = action.payload.schoolId ?? null;
                state.school = action.payload.school;
            } else {
                return initialState;

            }
        },
    },
});

export const { updateUserResponse } = userResponseSlice.actions;

export default userResponseSlice.reducer;